import React from 'react';
import { useStyles } from './CoverSummaryStyles';
import { Typography, TrustBox } from '../../atoms';
import { Box, Grid } from '@material-ui/core';
import { parse, format } from 'date-fns';
import { getDateFormat } from '../../../utils/dateFormattingUtils';
import clsx from 'clsx';

interface ICoverSummary {
  firstName: string;
  coverPrice: number | null;
  policyStartDate: Date | string | null | undefined;
}

export const CoverSummary: React.FC<ICoverSummary> = ({
  firstName,
  coverPrice,
  policyStartDate,
}: ICoverSummary): JSX.Element => {
  const classes = useStyles();
  const regex = /-/g;
  const startDateWithExpectedSeparators = policyStartDate? policyStartDate.toString().replace(regex,'/'): null;
  const formattedPolicyStartDate = startDateWithExpectedSeparators
    ? parse(startDateWithExpectedSeparators, getDateFormat(startDateWithExpectedSeparators), new Date())
    : null;
    const psd = formattedPolicyStartDate ? format(new Date(formattedPolicyStartDate), 'dd/MM/yyyy') : '';

  return (
    <Box className={classes.coverSummaryContainer}>
      <div className="pb2">
        <Typography className={clsx(classes.headings, classes.overflowHidden)} variant="h2">Hi {firstName}.</Typography>
      </div>
      <Typography className={classes.headings} variant="h2">
        Your policy will cost <span className={classes.greenHighlight}>£{coverPrice ? coverPrice.toFixed(2) : ''}</span>.
      </Typography>
      <div className="pt1">
        <Typography className={classes.headings} variant="h2">
          It&apos;ll start on <span className={classes.greenHighlight}>{psd ? psd : ''}</span>.
        </Typography>
      </div>
      <Box className={clsx(classes.trustBoxContainer, classes.mobileBreakPoint)}>
        <Box className="mb3 pb2">
          <Typography className={classes.headings} variant="h2">We&apos;re pretty confident you&apos;ll love it.</Typography>
        </Box>
        <TrustBox className={classes.trustBox} theme="dark" />
        {/* mobile layout */}
      </Box>
      <Grid>
        <Box className={clsx(classes.trustBoxContainer, classes.desktopBreakpoint)}>
          <Grid item md={6}>
            <Box className="mb3">
              <Typography className={clsx(classes.headings, 'pb2')} variant="h2">We&apos;re pretty confident you&apos;ll love it.</Typography>
            </Box>
          </Grid>
          <Grid item md={6}>
            <TrustBox className={classes.trustBox} theme="dark" />
            {/* desktop layout */}
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default CoverSummary;
